const getDaysBetweenDates = (startDate: number, endDate: number): number => {
  const diffInMs = endDate - startDate
  return Math.floor(diffInMs / (1000 * 60 * 60 * 24))
}

const dateIsAfter = (date: number, compareDate: number): boolean => {
  return date > compareDate
}

export { getDaysBetweenDates, dateIsAfter }
